
import Settings from '../components/settings/Settings.jsx';
import Forgot from '../pages/auth/Forgot.jsx';
import Login from '../pages/auth/Login.jsx';
import Otp from '../pages/auth/Otp.jsx';
import ResetPassword from '../pages/auth/ResetPassword.jsx';
import TFAuthenticator from '../pages/auth/TFAuthenticator.jsx';
import Clients from '../pages/clients/Clients.jsx';
import ClientDetails from '../pages/clients/components/ClientDetails.jsx';
import Communication from '../pages/communication/Communication.jsx';
import Dashboard from '../pages/dashboard/Dashboard.jsx';
import Files from '../pages/files/Files.jsx';
import ReviewFile from '../pages/files/ReviewFile.jsx';
import ViewFile from '../pages/files/ViewFile.jsx';
import Invoice from '../pages/invoice/Invoice.jsx';
import Banners from '../pages/banners/Banners.jsx';
import Pipeline from '../pages/pipeline/Pipeline.jsx';
import ViewPipeline from '../pages/pipeline/ViewPipeline.jsx';
import Services from '../pages/services/Services.jsx';
import ViewService from '../pages/services/ViewService.jsx';
import Tags from '../pages/setting/tags/Tags.jsx';
import Team from '../pages/team/Team.jsx';
import PaymentsReport from '../pages/payments/PaymentsReport.jsx';
import ImportClient from '../pages/importClient/ImportClient.jsx';
import FilesReport from '../pages/reports/FilesReport.jsx';
import InvoiceReport from '../pages/reports/InvoiceReport.jsx';
import SignatureReport from '../pages/reports/SignatureReport.jsx';
import FileTypes from '../pages/reports/FileTypes.jsx';
import ViewFileData from '../pages/reports/components/ViewFileData.jsx';
import Activity from '../pages/activity/Activity.jsx';
import RestoreClients from '../pages/restore/client/RestoreClients.jsx';
import Documents from '../pages/documents/Documents.jsx';
import ViewDocuments from '../pages/documents/components/ViewDocuments.jsx';
import RestoreFiles from '../pages/restore/files/RestoreFiles.jsx';
import SendInvoice from '../pages/files/SendInvoice.jsx';

export const initialRoutes = () => {
    const routes = [
        // ============ Auth ===============
        { path: "/login", type: "auth", component: Login, title: 'Login' },
        { path: "/otp", type: "auth", component: Otp, title: 'Otp' },
        { path: "/forget_password", type: "auth", component: Forgot, title: 'ForgotPassword' },
        { path: "/change_password/:token", type: "auth", component: ResetPassword, title: 'ResetPassword' },
        { path: "/authentication", type: "auth", component: TFAuthenticator, title: "Authentication" },
        { path: "*", type: "auth" },
        // ============ Public =============

        // ============ Privet ==============
        { path: "/", type: "private", component: Dashboard, title: "Dashboard" },
        { path: "/dashboard", type: "private", component: Dashboard, title: "Dashboard" },

        { path: "/services", type: "private", component: Files, title: "Services" },
        { path: "/file/:fileTypeId", type: "private", component: ViewFile, title: "Files" },
        { path: "/file/:fileTypeId/:id", type: "private", component: ReviewFile, title: "Files" },
        { path: "/file/:id/send_invoice", type: "private", component: SendInvoice, title: "Files" },

        { path: "/documents", type: "private", component: Documents, title: "Documents" },
        { path: "/document/:id", type: "private", component: ViewDocuments, title: "Documents" },

        { path: "/team", type: "private", accessRole: "admin", component: Team, title: "Team" },

        { path: "/clients", type: "private", component: Clients, title: "Clients" },
        { path: "/client_details/:id", type: "private", component: ClientDetails, title: "Clients" },
        { path: "/import_client", type: "private", accessRole: "admin", component: ImportClient, title: "Templates" },

        { path: "/service_flow", type: "private", accessRole: "admin", component: Pipeline, title: "Service Flow" },
        { path: "/service_flow/:id", type: "private", accessRole: "admin", component: ViewPipeline, title: "Service Flow" },

        { path: "/communication", type: "private", component: Communication, title: "Communication" },

        { path: "/service_templates", type: "private", accessRole: "admin", component: Services, title: "Templates" },
        { path: "/service_template/:serviceTypeId", type: "private", accessRole: "admin", component: ViewService, title: "Templates" },
        { path: "/invoice_templates", type: "private", accessRole: "admin", component: Invoice, title: "Templates" },

        { path: "/tags", type: "private", accessRole: "admin", component: Tags, title: "Settings" },
        { path: "/banners", type: "private", accessRole: "admin", component: Banners, title: "Settings" },
        { path: "/activity", type: "private", component: Activity, title: "Activity" },
        { path: "/settings", type: "private", component: Settings, title: "Settings" },

        { path: "/files_report", type: "private", component: FileTypes, title: "Files Report" },
        { path: "/files_report/:fileTypeId", type: "private", component: FilesReport, title: "Files Report" },
        { path: "/files_report/:fileTypeId/:id", type: "private", component: ViewFileData, title: "Files Report" },

        { path: "/payments_report", type: "private", component: PaymentsReport, title: "Payments Report" },
        { path: "/invoice_report", type: "private", component: InvoiceReport, title: "Invoice Report" },
        { path: "/signature_report", type: "private", component: SignatureReport, title: "Signature Report" },

        { path: "/restore_clients", type: "private", accessRole: "admin", component: RestoreClients, title: "Restore Clients" },
        { path: "/restore_files", type: "private", accessRole: "admin", component: RestoreFiles, title: "Restore Files" },
    ]
    return routes;
}